var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXrpup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.941 4h-4.334l-6.861 6.787a5.338 5.338 0 0 1-7.495 0L5.395 4h-4.34l9.027 8.934c3.27 3.234 8.568 3.234 11.836 0L30.942 4zM1.001 28.844H5.34l6.915-6.842a5.338 5.338 0 0 1 7.495 0l6.914 6.842H31l-9.082-8.99c-3.27-3.234-8.568-3.234-11.836 0L1 28.844z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrpup);
export default __webpack_public_path__ + "static/media/XRPUP.fd9c8b5b9f17925b6d24f0b74a346035.svg";
export { ForwardRef as ReactComponent };